import { SchedulerApp } from './SchedulerApp';
import { registerReactWebComponent } from '@/core/utils/webComponent';

export const registerSchedulerComponent = () => {
  registerReactWebComponent('content-scheduler', SchedulerApp);
};
